export const UPDATE_QUESTIONAIRE_CONSENT = "UPDATE_QUESTIONAIRE_CONSENT"
export const UPDATE_QUESTIONAIRE_CONSENT_SUCCESSFUL = "UPDATE_QUESTIONAIRE_CONSENT_SUCCESSFUL"
export const UPDATE_QUESTIONAIRE_CONSENT_FAILED = "UPDATE_QUESTIONAIRE_CONSENT_FAILED"
export const UPDATE_QUESTIONAIRE_CONSENT_RESET = "UPDATE_QUESTIONAIRE_CONSENT_RESET"